import React, { useState } from 'react';
import PlayerSearchResults from '../playerSearchResults/PlayerSearchResults';
import axiosConn from '../../axiosConn';

const SearchForPlayers = ({ player, onPlayerClick, autoFocus = false }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const handlePlayerSearch = async (value) => {
    setSearchTerm(value);
    if (value.length === 0) {
      setSearchResults([]);
      setSearching(false);
      return;
    }
    setSearching(true);
    try {
      const res = await axiosConn.get(`/players/regex/${value}`, {
        headers: { Authorization: `Bearer ${player.token}` },
      });
      setSearchResults(res.data.data.data);
    } catch (err) {
      setSearchResults([]);
    }
    setSearching(false);
  };

  return (
    <li className="drawer-searchbar-mobile" style={{ position: 'relative' }}>
      <input
        type="search"
        value={searchTerm}
        onChange={(e) => handlePlayerSearch(e.target.value)}
        placeholder="🔍 Search players"
        className="drawer-search-input"
        autoFocus={autoFocus}
      />
      {searching && <span className="drawer-search-loading">Searching...</span>}
      {searchTerm && (
        <div className="drawer-search-results drawer-search-results-overlay">
          <PlayerSearchResults
            searchedPlayers={searchResults}
            onPlayerClick={(playerObj) => {
              setSearchTerm('');
              setSearchResults([]);
              if (onPlayerClick) onPlayerClick(playerObj);
            }}
          />
          {searchResults.length === 0 && !searching && (
            <div className="drawer-search-no-results">No players found 😅</div>
          )}
        </div>
      )}
    </li>
  );
};

export default SearchForPlayers;
